

























































import Vue, { PropType } from "vue";

import * as ad from "@/store/modules/ApplicationModule/actions";
import { mapActions, mapGetters, mapState } from "vuex";
import { RootState } from "@/store";

import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import DeviceFolderTree from "@/components/DeviceFolderTree.vue";
import TagsFilter from "@/components/TableHeaderFilters/TagsFilter.vue";

import { WidgetTypesEnum } from "@/model/data/dashboard/WidgetTypesEnum";

import CashCountFilter from "./CashCount/Filter.vue";
import CashDistributionFilter from "./CashDistribution/Filter.vue";
import TransactionsFilter from "./Transactions/Filter.vue";
import SoftwareVersionsFilter from "./SoftwareVersions/Filter.vue";
import InstallationSummaryFilter from "./InstallationSummary/InstallationSummaryFilter.vue";

import { TagValues } from "@/model/data/Tag";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";

export default Vue.extend({
    components: {
        DeviceFolderTree,
        CashCountFilter,
        CashDistributionFilter,
        TransactionsFilter,
        SoftwareVersionsFilter,
        TagsFilter,
        InstallationSummaryFilter,
    },
    data() {
        return {
            WidgetTypesEnum,
            ClientPrivileges,
            loadingModels: false,
        };
    },
    computed: {
        ...mapState({
            availableMachineModels: (state: RootState): Map<LicenseModuleEnum, string[]> => state.application.availableMachineModels,
        }),
        availableMachineModelsFiltered() {
            if (this.availableMachineModels == null || this.availableMachineModels == undefined) return this.availableMachineModels;
            return this.availableMachineModels[LicenseModuleEnum[LicenseModuleEnum.ServiceAndUpdatesManagement]];
        },
        ...mapGetters(["authUserHasPrivilege"]),
        // currentComp() {
        //     const type = _.find(this.availableFilter, (v) => {
        //         return v.idx == this.WidgetConfig.Type;
        //     });
        //     // console.log("retrieved type", type);
        //     return type;
        // },
    },
    props: {
        widget: Object as PropType<DashboardWidget>,
    },
    methods: {
        ...mapActions([ad.GET_AVAILABLE_MACHINE_MODELS]),
        addNewTagFilter() {
            (this.widget as DashboardWidget).filter.byTag.push(new TagValues());
        },
        removeLastTagFilter() {
            (this.widget as DashboardWidget).filter.byTag.pop();
        },
    },
    async mounted() {
        if (!this.availableMachineModels || !this.availableMachineModels.length) {
            this.loadingModels = true;
            await this[ad.GET_AVAILABLE_MACHINE_MODELS]();
            this.loadingModels = false;
        }
    },
});
